export enum LoginStepType {
	Email = 0,
	Middle = 1,
	Last = 2,
}

export default LoginStepType;
